import apiClient from './api.ts';
import {
    BreakPeriodInputSchema,
    AuthenticationSchema,
    PasswordPolicySchema,
    PolicySettingSchema, RetentionSettingSchema
} from '@/types/setting_schema.ts';
import { SchoolAddressSchema, SchoolContactSchema, SchoolPreferenceSchema, SchoolInfoUpdate } from '@/types/school_schema.ts';

export default {
    async getAllSchool() {
        return await apiClient.get(`schools/user`);
    },
    // Note: selectSchool API removed - school selection is now header-based only
    async getSchoolById(id: number) {
        return await apiClient.get(`schools/${id}`);
    },
    async getAllBreakPeriodForSchool(schoolId: number) {
        return await apiClient.get(`schools/${schoolId}/setting/break-period/list`);
    },
    async createBreakPeriod(schoolId: number, data: BreakPeriodInputSchema) {
        return await apiClient.post(`schools/${schoolId}/setting/break-period/create`, data);
    },
    async updateBreakPeriod(id: number, schoolId: number, update: BreakPeriodInputSchema) {
        return await apiClient.put(`schools/${schoolId}/setting/break-period/${id}/update`, update);
    },
    async deleteBreakPeriod(id: number, schoolId: number) {
        return await apiClient.delete(`schools/${schoolId}/setting/break-period/${id}`);
    },
    async getSchoolTypes() {
        return await apiClient.get(`schools/type/list`);
    },
    // School is resolved from the tenant header, not the path. Code changes go through renameSchoolCode.
    async updateSchoolInfo(update: SchoolInfoUpdate) {
        return await apiClient.put(`schools`, update);
    },
    async createSchoolAddress(schoolId: number, input: SchoolAddressSchema) {
        return await apiClient.post(`schools/${schoolId}/address`, input);
    },
    async createSchoolContact(schoolId: number, input: SchoolContactSchema) {
        return await apiClient.post(`schools/${schoolId}/contact`, input);
    },
    async createSchoolPreference(schoolId: number, input: SchoolPreferenceSchema) {
        return await apiClient.post(`schools/${schoolId}/preference`, input);
    },
    async updateSchoolAddress(id: number, schoolId: number, update: SchoolAddressSchema) {
        return await apiClient.put(`schools/${schoolId}/address/${id}/update`, update);
    },
    async updateSchoolContact(id: number, schoolId: number, update: SchoolContactSchema) {
        return await apiClient.put(`schools/${schoolId}/contact/${id}/update`, update);
    },
    async updateSchoolPreference(id: number, schoolId: number, update: SchoolPreferenceSchema) {
        return await apiClient.put(`schools/${schoolId}/preference/${id}/update`, update);
    },
    async getAuthenticationSetting() {
        return await apiClient.get(`schools/setting/authentication`);
    },
    async createAuthenticationSetting(input: AuthenticationSchema) {
        return await apiClient.post(`schools/setting/authentication`, input);
    },
    async updateAuthenticationSetting(id: number, update: AuthenticationSchema) {
        return await apiClient.put(`schools/setting/authentication/${id}/update`, update);
    },
    async getPasswordPolicySetting() {
        return await apiClient.get(`schools/setting/password-policy`);
    },
    async createPasswordPolicySetting(input: PasswordPolicySchema) {
        return await apiClient.post(`schools/setting/password-policy`, input);
    },
    async updatePasswordPolicySetting(id: number, update: PasswordPolicySchema) {
        return await apiClient.put(`schools/setting/password-policy/${id}/update`, update);
    },
    async getSubscriptionPlanOfSchool(schoolId: number) {
        return await apiClient.get(`schools/${schoolId}/subscription-plan`);
    },
    async getSchoolUsageOfPlan(schoolId: number) {
        return await apiClient.get(`schools/${schoolId}/subscription-plan/usage`);
    },
    async getRetentionSetting(schoolId: number) {
        return await apiClient.get(`schools/${schoolId}/setting/retention`);
    },
    async createRetentionSetting(schoolId: number, input: RetentionSettingSchema) {
        return await apiClient.post(`schools/${schoolId}/setting/retention`, input);
    },
    async updateRetentionSetting(id: number, schoolId: number, update: RetentionSettingSchema) {
        return await apiClient.put(`schools/${schoolId}/setting/retention/${id}/update`, update);
    },
    async getPolicySetting(schoolId: number) {
        return await apiClient.get(`schools/${schoolId}/setting/policy`);
    },
    async createPolicySetting(schoolId: number, input: PolicySettingSchema) {
        return await apiClient.post(`schools/${schoolId}/setting/policy`, input);
    },
    async updatePolicySetting(id: number, schoolId: number, update: PolicySettingSchema) {
        return await apiClient.put(`schools/${schoolId}/setting/policy/${id}/update`, update);
    },
    async renameSchoolCode(schoolId: number, payload: { old_code: string; new_code: string }) {
        return await apiClient.post(`schools/${schoolId}/rename-code`, payload);
    },
};
